export { errors } from './errors.js';
export { icons } from './icons.js';
export { formFields } from './formFields.js';
export {
  userModel,
  paginationModel,
  loginModel,
  drugsModel,
  establishmentModel,
  regionModel,
  citiesModel,
  responseModel,
  stakeholderModel,
  unitsModel,
  mailModel,
  stakeholderGradesModel,
  ticketModel } from './models.js';

export {
  stakeholderOperationPortalPrivileges,
  privilegesType,
  stakeholderUsersServicePrivileges
} from './privileges.js';

export const portals = {
  MANAGEMENT: 'mp',
  STAKEHOLDER_MANAGEMENT: 'smp',
  STAKEHOLDER_OPERATION: 'sop'
};

export const languages = {
  EN: 'en',
  AR: 'ar',
  AR_TITLE: 'العربية',
  EN_TITLE: 'English'
};

export const CANCELED_BY_CLIENT = 'Canceled by client';

export const notificationTypes = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

export const actions = {
  REQUEST: 'REQUEST',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  CLEAR_ERROR: 'CLEAR_ERROR',
  CLEAR_ALL: 'CLEAR_ALL',
  CANCELED: 'CANCELED'
};

export const MAX_EXCEL_RECORDS = 1000000;
export const HIDDEN_ROUTE = '99999';
export const yesNo = {
  'Yes': '1',
  'No': '0',
  'نعم': '1',
  'لا': '0'
};

export const strengthValueUnitOptions = [
  { text: '%', value: '1' },
  { text: 'µg', value: '2' },
  { text: 'µg/ml', value: '3' },
  { text: 'DOSE', value: '22' },
  { text: 'g', value: '4' },
  { text: 'g/l', value: '5' },
  { text: 'g/ml ', value: '6' },
  { text: 'iu', value: '9' },
  { text: 'IU', value: '7' },
  { text: 'IU/ml', value: '8' },
  { text: 'kBq/ml', value: '10' },
  { text: 'mEq', value: '11' },
  { text: 'mEq/g', value: '12' },
  { text: 'mEq/ml', value: '13' },
  { text: 'mg', value: '14' },
  { text: 'mg/g', value: '15' },
  { text: 'mg/ml', value: '16' },
  { text: 'ml', value: '17' },
  { text: 'mMol', value: '18' },
  { text: 'mMol/ml', value: '19' },
  { text: 'PFU', value: '21' },
  { text: 'U', value: '20' }
];

export const strengthValueUnitFormValue = raw => {
  if (raw == null || raw === '') {

    return { text: '', value: '' };
  }

  if (typeof raw === 'object' && raw.value != null) {

    return { text: raw.text ?? '', value: String(raw.value) };
  }

  const s = String(raw).trim();
  const opt = strengthValueUnitOptions.find(o => o.value === s)
    || strengthValueUnitOptions.find(o => String(o.text).trim() === s);

  return opt ? { text: opt.text, value: opt.value } : { text: s, value: s };
};

export const strengthValueUnitApiValue = u => {
  if (u == null || u === '') {

    return u;
  }

  if (typeof u === 'object' && u.value != null && u.value !== '') {

    return u.value;
  }

  if (typeof u === 'object' && u.text) {
    const m = strengthValueUnitOptions.find(o => String(o.text).trim() === String(u.text).trim());

    return m?.value ?? u.text;
  }

  return u;
};
